import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import dayjs from 'dayjs';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

const MAGIC_STRING = 'XQQZ';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (request.body) {
      try {
        this.logFields(request.body, request.url);
      } catch {}
    }
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        const timestamp = dayjs.utc().valueOf();
        throw request.url.includes('medusa')
          ? {
              requestData: { request, timestamp },
              response: error
            }
          : error;
      })
    );
  }

  /**
   * Traverses the object and logs the fields that are of interest,
   * in particular those that might leak private data (esp. for CACIB)
   * @param message
   * @param url
   */
  public logFields(message: any, url: string) {
    const walkNestedObject = (obj: any) => {
      if (Array.isArray(obj)) {
        for (var i in obj) {
          walkNestedObject(obj[i]);
        }
      } else {
        for (var key in obj) {
          const val = obj[key];
          if (typeof val === 'object' && val != null) {
            walkNestedObject(val);
          } else if (typeof val === 'string') {
            if (val.includes(MAGIC_STRING)) {
              console.error('Found potential private data leak', url, key, val);
            }
            switch (key) {
              case 'counterPartyA':
              case 'counterPartyB':
              case 'primeBroker':
              case 'account':
              case 'aggregateLegsEntity':
              case 'entity':
                if (!['-', 'None', ''].includes(val)) {
                  console.log('Found', url, key, val);
                }
            }
          }
        }
      }
    };

    walkNestedObject(message);
  }
}
